import { createReducer, combineReducers } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as actions from './actions';

export interface HealthRecordsSummaryDownloadState {
  isDownloading: boolean;
  error: Nullable<Error>;
}
export interface HealthRecordsSummaryState {
  healthRecordsDownload: HealthRecordsSummaryDownloadState;
  shareHealthRecordSummary: ShareHealthRecordSummaryState;
}
export interface ShareHealthRecordSummary {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareHealthRecordSummaryState {
  isSendingHealthRecordSummary: boolean;
  sharedHealthRecordSummaryData: ShareHealthRecordSummary | {};
  sharedHealthRecordSummaryError: Nullable<Error>;
}

export const HealthRecordsSummaryDownloadInitialState = (): HealthRecordsSummaryDownloadState => ({
  isDownloading: false,
  error: null
});
export const shareHealthRecordSummaryInitialState = (): ShareHealthRecordSummaryState => ({
  isSendingHealthRecordSummary: false,
  sharedHealthRecordSummaryData: {},
  sharedHealthRecordSummaryError: null
});

const shareHealthRecordSummaryReducer = createReducer(shareHealthRecordSummaryInitialState(), {
  [actions.SHARE_HEALTH_RECORD_SUMMARY]: state => {
    state.isSendingHealthRecordSummary = true;
    state.sharedHealthRecordSummaryError = null;
  },
  [actions.SHARE_HEALTH_RECORD_SUMMARY_SUCCESS]: (state, action) => {
    state.isSendingHealthRecordSummary = false;
    state.sharedHealthRecordSummaryData = action.payload.data;
  },
  [actions.SHARE_HEALTH_RECORD_SUMMARY_FAIL]: (state, action) => {
    state.isSendingHealthRecordSummary = false;
    state.sharedHealthRecordSummaryError = action.error;
  }
});

const healthRecordsDownloadReducer = createReducer(HealthRecordsSummaryDownloadInitialState(), {
  [actions.DOWNLOAD_HEALTH_RECORDS_SUMMARY]: state => {
    state.isDownloading = true;
    state.error = null;
  },
  [actions.DOWNLOAD_HEALTH_RECORDS_SUMMARY_SUCCESS]: state => {
    state.isDownloading = false;
  },
  [actions.DOWNLOAD_HEALTH_RECORDS_SUMMARY_FAIL]: (state, action) => {
    state.isDownloading = false;
    state.error = action.error;
  }
});
export default combineReducers({
  healthRecordsDownload: healthRecordsDownloadReducer,
  shareHealthRecordSummary: shareHealthRecordSummaryReducer
});
